import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { trpc } from 'api'
import { Customer, VerifyStrategyType } from '@ca/common/types'
import { useToast } from '@ui/toasts/useToastManager'

export const useStaffLoginCustomer = () => {
  const verifyRequest = trpc.customer.verifyRequest.useMutation()
  const toast = useToast()
  const { t } = useTranslation(['toasts'])

  const [customer, setCustomer] = useState<Customer | undefined>()
  const [pendingStrategy, setPendingStrategy] = useState<
    VerifyStrategyType | undefined
  >()

  const request = (customer: Customer, _strategy?: VerifyStrategyType) => {
    setCustomer(customer)
    if (!customer.ref) {
      return
    }

    const strategy = _strategy || 'email'
    setPendingStrategy(strategy)

    verifyRequest.mutate(
      {
        login: customer.ref || '',
        strategy,
      },
      {
        onError: () => {
          setPendingStrategy(undefined)
          toast({
            variant: 'error',
            title: t('toasts:error.default.title'),
            text: t('toasts:error.default.desc'),
          })
        },
      }
    )
  }

  const cancel = () => {
    setPendingStrategy(undefined)
    verifyRequest.reset()
  }

  return {
    request,
    cancel,
    customer,
    result: verifyRequest.data,
    isLoading: verifyRequest.isPending,
    pendingStrategy,
  }
}
